import { deleteInvitationDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteInvitationCallable = getCallable(deleteInvitationDefinition);
